import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { Observable, take, tap } from 'rxjs';
import { FileUploadService } from '../../file-upload/file-upload.service';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ImportDiaologTableService } from '../import-dialog-table/import-dialog-table.service';
import { FileUploadComponent } from '../../file-upload/file-upload.component';
import { ImportDialogTableComponent } from '../import-dialog-table/import-dialog-table.component';

export interface DialogData {
  fileData: string[];
  columnData: any;
  sourceName: string;
}

@Component({
  selector: 'dl-import-dialog-file',
  standalone: true,
  imports: [OneWebComponentsAngularModule, FileUploadComponent, ImportDialogTableComponent, ReactiveFormsModule],
  templateUrl: './import-dialog-file.component.html',
  styleUrl: './import-dialog-file.component.scss',
  providers: [FileUploadService, ImportDiaologTableService]
})
export class ImportDialogFileComponent {

  public filename = new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*')]);

  public importButton = true;
  public getImportData: Observable<string>;
  public checkdropdownFlag: string;
  @Input() inputData: any;
  public data: any = {};
  @Output() dialogClose = new EventEmitter<any>();
  public fileData: any;    // or appropriate type like Array<any>
  public columnData: any;  // or appropriate type like object
  public sourceName: string;

  public constructor(
    private fileuploadService: FileUploadService, 
    private importDiaologTableService: ImportDiaologTableService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }


 public onImportbtnCheckData(): Observable<string> {
  return this.fileuploadService.checkValidDataobservable$;
}

public ngOnInit(): void {
  this.getImportData = this.onImportbtnCheckData();

  this.getImportData.subscribe(d => {
    this.checkdropdownFlag = d;
    if (d === 'Import button Active' && this.filename.valid) {
      this.importButton = false;
      this.data.sourceName = this.filename.value;
    } else {
      this.importButton = true;
    }
    this.changeDetectorRef.detectChanges();
  });

  this.filename.valueChanges.subscribe(x => {
    if (this.checkdropdownFlag === 'Import button Active' && this.filename.valid) {
      this.importButton = false;
      this.data.sourceName = this.filename.value;
    } else {
      this.importButton = true;
      this.filename.markAsDirty();
    }
    this.changeDetectorRef.detectChanges();
  });
}



  public onFileUpload(evt: any): void {
   

    if (evt !== undefined) {
      let filenameOnupload, filenameOnuploadValid: string;
      if (evt.fileDetails.name) {
        filenameOnupload = evt.fileDetails.name.split('.')[0];
        filenameOnuploadValid = filenameOnupload.replace(/[^a-zA-Z ]/g, '');
        if (filenameOnuploadValid.length > 25) {
          filenameOnuploadValid = filenameOnuploadValid.slice(0, 25);
        }
      }
      evt.fileDetails.name ? this.filename.setValue(filenameOnuploadValid) : this.filename.setValue('');
      this.fileuploadService.sheetToJsonDataobservable$.pipe(take(1)).subscribe(d => {
        this.fileData = d;
      });

      this.importDiaologTableService.mappingData$.pipe(take(1)).subscribe(impData => {
        this.columnData = impData;
      });

      this.sourceName = this.filename.value;
    }
  }

  onImport() {
    const dataToReturn = {
      fileData: this.fileData,
      columnData: this.columnData,
      sourceName: this.filename.value || this.sourceName
    };
    this.dialogClose.emit(dataToReturn);
  }

  // Call this method on Cancel button click, close dialog without data or with null
  onCancel() {
    this.dialogClose.emit(null);
  }
}
